function template(data) {
  return `
    <cms-difm-promo-banner>
		<div class="ws-difm-banner">
			<div class="ws-difm-banner__container">
				<div class="ws-difm-banner__title-container">
					<div class="ws-difm-banner__title">${data.title}</div>

					<div class="ws-difm-banner__description">
						${data.description}
						<span class="ws-difm-banner__plan-name">
							Yola <span class="ws-difm-banner__diadem">G</span>old
						</span>
					</div>
				</div>

				<div class="ws-difm-banner__cta-container">
					<div class="ws-difm-banner__reviews">
						<div class="ws-difm-banner__avatar-list">
							<div class="ws-difm-banner__avatar-item">
								<img src="https://assets.yolacdn.net/difm/images/avatar-1-279439e8.png" alt="avatar-1">
							</div>
							<div class="ws-difm-banner__avatar-item">
								<img src="https://assets.yolacdn.net/difm/images/avatar-2-4d3b909f.png" alt="avatar-2">
							</div>
							<div class="ws-difm-banner__avatar-item">
								<img src="https://assets.yolacdn.net/difm/images/avatar-5-818542c5.png" alt="avatar-3">
							</div>
						</div>
						<div class="ws-difm-banner__rating"></div>
						<div class="ws-difm-banner__review-text">${data.reviewText}</div>
					</div>

					<button type="button" class="ws-difm-banner__cta-button">
						<span class="ws-difm-banner__cta-button-text">${data.buttonText}</span>
					</button>
				</div>
			</div>
		</div>
    </cms-difm-promo-banner>
	`.trim();
}

export default template;
